// Sort control for the voice library and category hubs (design language F).
// The keys map 1:1 onto the `sortBy` values /api/model accepts - don't add an
// option here that the API's zod enum doesn't know, it would 400.
import React from "react";

export const VOICE_SORTS = {
  hot: {
    sortBy: "usesLast24Hours",
    label: "Trending today",
    short: "Trending",
  },
  top: { sortBy: "uses", label: "Most used", short: "Most used" },
  liked: { sortBy: "likes", label: "Most liked", short: "Most liked" },
  new: { sortBy: "createdAt", label: "Newest", short: "Newest" },
} as const;

export type VoiceSortKey = keyof typeof VOICE_SORTS;

const VoiceSortTabs = ({
  value,
  onChange,
}: {
  value: VoiceSortKey;
  onChange: (value: VoiceSortKey) => void;
}) => (
  <div
    role="tablist"
    aria-label="Sort voices"
    className="tw-flex tw-gap-1.5 tw-overflow-x-auto md:tw-gap-1 md:tw-rounded-full md:tw-bg-jam-lav md:tw-p-1 [&::-webkit-scrollbar]:tw-hidden"
  >
    {(Object.keys(VOICE_SORTS) as VoiceSortKey[]).map((key) => {
      const active = key === value;
      return (
        <button
          key={key}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(key)}
          className={`tw-flex-shrink-0 tw-cursor-pointer tw-whitespace-nowrap tw-rounded-full tw-border-2 tw-border-solid tw-px-3 tw-py-1.5 tw-text-xs tw-font-extrabold md:tw-border-0 md:tw-px-3.5 md:tw-py-2 md:tw-text-[13px] ${
            active
              ? "tw-border-jam-ink tw-bg-jam-ink tw-text-white md:tw-bg-white md:tw-text-jam-purple"
              : "tw-border-jam-line tw-bg-transparent tw-text-jam-ink"
          }`}
        >
          <span className="md:tw-hidden">{VOICE_SORTS[key].short}</span>
          <span className="tw-hidden md:tw-inline">
            {VOICE_SORTS[key].label}
          </span>
        </button>
      );
    })}
  </div>
);

export default VoiceSortTabs;
